document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const close = document.querySelector('[data-menu-close]');
  const menu = document.querySelector('#MobileMenu');
  const menuBackdrop = document.querySelector('[data-menu-backdrop]');
  const setMenu = (open) => {
    if (!menu || !toggle) return;
    menu.hidden = !open;
    if (menuBackdrop) menuBackdrop.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('menu-open', open);
  };
  toggle?.addEventListener('click', () => setMenu(true));
  close?.addEventListener('click', () => setMenu(false));
  menuBackdrop?.addEventListener('click', () => setMenu(false));
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenu(false); });

  const siteHeader = document.querySelector('[data-header]');
  if (siteHeader) {
    const headerSection = siteHeader.closest('.shopify-section');
    headerSection?.classList.add('site-header-section');
  }

  const overlayHeader = document.querySelector('.site-header--overlay');
  if (overlayHeader) {
    const syncHeader = () => overlayHeader.classList.toggle('is-scrolled', window.scrollY > 28);
    syncHeader();
    window.addEventListener('scroll', syncHeader, { passive: true });
  }

  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('[data-carousel-slide]')];
    const dots = [...carousel.querySelectorAll('[data-carousel-dot]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer = null;
    const delay = Number(carousel.dataset.delay) || 6000;
    carousel.style.setProperty('--carousel-delay', `${delay}ms`);

    const restartProgress = () => {
      dots.forEach((dot) => dot.classList.remove('is-progressing'));
      const activeDot = dots[index];
      if (!activeDot) return;
      void activeDot.offsetWidth;
      activeDot.classList.add('is-progressing');
    };

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      restartProgress();
    };

    const stop = () => {
      if (timer) clearTimeout(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (carousel.dataset.autoplay !== 'true') return;
      timer = setTimeout(() => {
        show(index + 1);
        start();
      }, delay);
    };

    const go = (next) => {
      show(next);
      start();
    };

    carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => go(index - 1));
    carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => go(index + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => go(Number(dot.dataset.carouselDot))));

    let touchX = null;
    carousel.addEventListener('touchstart', (event) => {
      touchX = event.touches[0]?.clientX ?? null;
    }, { passive: true });
    carousel.addEventListener('touchend', (event) => {
      if (touchX === null) return;
      const diff = (event.changedTouches[0]?.clientX ?? touchX) - touchX;
      if (Math.abs(diff) > 40) go(diff < 0 ? index + 1 : index - 1);
      touchX = null;
    });

    show(0);
    start();
  });

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const stage = gallery.querySelector('[data-gallery-stage]');
    if (!slides.length) return;
    const isMobile = () => window.matchMedia('(max-width: 989px)').matches;
    const normalize = (value) => String(value || '').split('/').pop();
    const normalizeUrl = (value) => {
      try {
        const url = new URL(String(value || ''), window.location.origin);
        return `${url.hostname}${url.pathname}`.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|\d+x\d*)?(?=\.[a-z]+$)/i, '');
      } catch {
        return String(value || '').split('?')[0];
      }
    };
    const normalizeText = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('pt-BR');
    const activate = (index, shouldScroll = isMobile()) => {
      if (index < 0 || index >= slides.length) return false;
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', String(active));
      });
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      if (shouldScroll) {
        slides[index]?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
      return true;
    };
    gallery.activateMedia = (mediaId, colorName, mediaSrc) => {
      const normalizedId = normalize(mediaId);
      let index = normalizedId
        ? slides.findIndex((item) => normalize(item.dataset.mediaId) === normalizedId)
        : -1;
      if (index < 0 && mediaSrc) {
        const normalizedSrc = normalizeUrl(mediaSrc);
        index = slides.findIndex((item) => {
          const itemSrc = item.dataset.mediaSrc || item.querySelector('img')?.currentSrc || item.querySelector('img')?.src;
          return normalizeUrl(itemSrc) === normalizedSrc;
        });
      }
      if (index < 0 && colorName) {
        const color = normalizeText(colorName);
        const aliases = color.includes('rosa') || color.includes('pink')
          ? ['rosa', 'pink']
          : color.includes('azul') || color.includes('blue')
            ? ['azul', 'blue']
            : color.includes('bege') || color.includes('beige')
              ? ['bege', 'beige']
              : [color];
        index = slides.findIndex((item) => {
          const alt = normalizeText(item.dataset.mediaAlt || item.querySelector('img')?.alt);
          return aliases.some((alias) => alt.includes(alias));
        });
      }
      return activate(index, isMobile());
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => activate(Number(thumb.dataset.galleryThumb))));
    if (stage && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!isMobile()) return;
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = slides.indexOf(entry.target);
          thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === index));
        });
      }, { root: stage, threshold: 0.6 });
      slides.forEach((slide) => observer.observe(slide));
    }
  });

  document.querySelectorAll('[data-counter-for]').forEach((counter) => {
    const field = document.getElementById(counter.dataset.counterFor);
    if (!field) return;
    const max = Number(field.dataset.counterMax) || Number(field.getAttribute('maxlength')) || 0;
    const render = () => {
      if (field.value.length > max) field.value = field.value.slice(0, max);
      counter.textContent = `${field.value.length}/${max} caracteres`;
    };
    field.addEventListener('input', render);
    render();
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const json = section.querySelector('[data-product-json]');
    const form = section.querySelector('[data-product-form]');
    if (!json || !form) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent || '[]'); } catch {}
    let inventoryVariants = [];
    const inventoryJson = section.querySelector('[data-product-inventory-json]');
    try { inventoryVariants = JSON.parse(inventoryJson?.textContent || '[]'); } catch {}
    const options = [...form.querySelectorAll('[data-option-position]')];
    const id = form.querySelector('[data-variant-id]');
    const button = form.querySelector('[data-add-button]');
    const label = form.querySelector('[data-add-label]');
    const price = section.querySelector('[data-price]');
    const payment = section.querySelector('[data-product-payment]');
    const countdown = section.querySelector('[data-promotion-countdown]');
    const mobileCta = section.querySelector('[data-mobile-product-cta]');
    const mobileCtaPrice = mobileCta?.querySelector('[data-mobile-product-price]');
    const money = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'BRL'
    });
    let countdownTimer = null;
    const renderCountdown = (onSale) => {
      if (!countdown) return;
      const end = Date.parse(countdown.dataset.end || '');
      if (!onSale || Number.isNaN(end)) {
        countdown.hidden = true;
        if (countdownTimer) clearInterval(countdownTimer);
        countdownTimer = null;
        return;
      }
      countdown.hidden = false;
      const tick = () => {
        const remaining = Math.max(0, end - Date.now());
        const ended = remaining === 0;
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        const hoursEl = countdown.querySelector('[data-countdown-hours]');
        const minutesEl = countdown.querySelector('[data-countdown-minutes]');
        const secondsEl = countdown.querySelector('[data-countdown-seconds]');
        const timeEl = countdown.querySelector('.promotion-countdown__time');
        const endedEl = countdown.querySelector('[data-countdown-ended]');
        const setValue = (element, value) => {
          if (!element || element.textContent === value) return;
          element.textContent = value;
          element.classList.remove('is-changing');
          void element.offsetWidth;
          element.classList.add('is-changing');
        };
        setValue(hoursEl, String(hours).padStart(2, '0'));
        setValue(minutesEl, String(minutes).padStart(2, '0'));
        setValue(secondsEl, String(seconds).padStart(2, '0'));
        if (timeEl) timeEl.hidden = ended;
        if (endedEl) endedEl.hidden = !ended;
        if (ended && countdownTimer) { clearInterval(countdownTimer); countdownTimer = null; }
      };
      if (countdownTimer) clearInterval(countdownTimer);
      tick();
      if (end > Date.now()) countdownTimer = setInterval(tick, 1000);
    };
    const renderAvailability = () => {};
    const update = () => {
      const selected = {};
      options.filter((option) => option.checked).forEach((option) => { selected[Number(option.dataset.optionPosition) - 1] = option.value; });
      const variant = variants.find((item) => item.options.every((option, index) => selected[index] === undefined || selected[index] === option));
      if (!variant) return;
      if (id) id.value = variant.id;
      if (button) button.disabled = !variant.available;
      if (label) label.textContent = variant.available ? 'Adicionar à sacola' : 'Esgotado';
      if (mobileCta) mobileCta.disabled = !variant.available;
      if (mobileCtaPrice) mobileCtaPrice.textContent = money.format(variant.price / 100);
      renderAvailability(variant);
      const onSale = Number(variant.compare_at_price) > Number(variant.price);
      if (price) {
        const current = price.querySelector('[data-current-price]');
        const compare = price.querySelector('[data-compare-price]');
         const discount = price.querySelector('[data-discount-badge]');
        if (current) current.textContent = money.format(variant.price / 100);
        if (compare) {
          compare.hidden = !onSale;
          compare.textContent = onSale ? money.format(variant.compare_at_price / 100) : '';
        }
         if (discount) {
           const discountPercent = onSale ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100) : 0;
           discount.hidden = !onSale;
           discount.textContent = onSale ? `${discountPercent}% OFF` : '';
         }
        price.classList.toggle('price--sale', onSale);
      }
      if (payment) {
        const pixDiscount = Number(payment.dataset.pixDiscount) || 0;
        const installments = Math.max(1, Number(payment.dataset.cardInstallments) || 1);
        const pixPrice = payment.querySelector('[data-pix-price]');
        const cardPrice = payment.querySelector('[data-card-price]');
        const cardCount = payment.querySelector('[data-card-count]');
        if (pixPrice) pixPrice.textContent = money.format((variant.price * (100 - pixDiscount)) / 10000);
        if (cardPrice) cardPrice.textContent = money.format(variant.price / installments / 100);
        if (cardCount) cardCount.textContent = String(installments);
      }
      renderCountdown(onSale);
      const gallery = section.querySelector('[data-gallery]');
       if (typeof gallery?.activateMedia === 'function') {
         const colorOption = options.find((option) => {
           const legend = option.closest('fieldset')?.querySelector('legend')?.textContent || '';
           return /\b(cor|color|colour)\b/i.test(legend);
         });
         const colorName = colorOption?.value || '';
          const featuredMediaId = variant.featured_media?.id;
          const featuredImageId = variant.featured_image?.id;
          const featuredMediaSrc = variant.featured_media?.preview_image?.src;
          const featuredImageSrc = variant.featured_image?.src;
          const activatedByMedia = featuredMediaId || featuredMediaSrc ? gallery.activateMedia(featuredMediaId, '', featuredMediaSrc) : false;
          const activatedByImage = !activatedByMedia && (featuredImageId || featuredImageSrc) ? gallery.activateMedia(featuredImageId, '', featuredImageSrc) : false;
         if (!activatedByMedia && !activatedByImage) gallery.activateMedia('', colorName);
       }
      history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    };
    options.forEach((option) => option.addEventListener('change', update));
    update();

    if (mobileCta && button) {
      const mobileMedia = window.matchMedia('(max-width: 749px)');
      const setMobileCta = (visible) => {
        const shouldShow = mobileMedia.matches && visible;
        mobileCta.hidden = !shouldShow;
        document.body.classList.toggle('product-mobile-cta-visible', shouldShow);
      };
      const updateMobileCtaVisibility = () => {
        if (!mobileMedia.matches) { setMobileCta(false); return; }
        const rect = button.getBoundingClientRect();
        const header = document.querySelector('.site-header');
        const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
        /* Só mostra depois que o botão original saiu pela parte superior da tela.
           Se ele ainda está abaixo da viewport (antes de chegar nele), permanece oculto. */
        setMobileCta(rect.bottom <= Math.max(0, headerBottom));
      };
      let mobileCtaTicking = false;
      const requestMobileCtaUpdate = () => {
        if (mobileCtaTicking) return;
        mobileCtaTicking = true;
        window.requestAnimationFrame(() => {
          updateMobileCtaVisibility();
          mobileCtaTicking = false;
        });
      };
      window.addEventListener('scroll', requestMobileCtaUpdate, { passive: true });
      window.addEventListener('resize', requestMobileCtaUpdate);
      if (typeof mobileMedia.addEventListener === 'function') mobileMedia.addEventListener('change', requestMobileCtaUpdate);
      else if (typeof mobileMedia.addListener === 'function') mobileMedia.addListener(requestMobileCtaUpdate);
      updateMobileCtaVisibility();

      mobileCta.addEventListener('click', () => {
        const personalization = form.querySelector('.personalization');
        (personalization || button).scrollIntoView({ behavior: 'smooth', block: 'start' });
        const firstRequired = form.querySelector('.personalization [required]');
        window.setTimeout(() => firstRequired?.focus({ preventScroll: true }), 450);
      });
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const tooLong = [...form.querySelectorAll('[data-counter-max]')].find((field) => field.value.length > Number(field.dataset.counterMax));
      const error = form.querySelector('[data-product-error]');
      if (tooLong) {
        tooLong.focus();
        if (error) { error.hidden = false; error.textContent = 'Texto acima do limite de caracteres permitido.'; }
        return;
      }
      if (!form.checkValidity()) { form.reportValidity(); return; }
      const originalLabel = label?.textContent || 'Adicionar à sacola';
      if (button) button.disabled = true;
      if (label) label.textContent = 'Adicionando...';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        });
        const data = await response.json();
        if (!response.ok) throw data;
        await window.StorkidsCartDrawer?.refresh(true);
      } catch (err) {
        if (error) { error.hidden = false; error.textContent = err?.description || 'Não foi possível adicionar o produto à sacola.'; }
      } finally {
        if (button) button.disabled = false;
        if (label) label.textContent = originalLabel;
      }
    });
  });



  document.querySelectorAll('[data-product-info-tabs]').forEach((section) => {
    const tabs = [...section.querySelectorAll('[data-tab-trigger]')];
    const panels = [...section.querySelectorAll('[data-tab-panel]')];
    if (!tabs.length || !panels.length) return;
    const activate = (target) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.tabTrigger === target;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach((panel) => {
        const active = panel.dataset.tabPanel === target;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab.dataset.tabTrigger));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        tabs[nextIndex].focus();
        activate(tabs[nextIndex].dataset.tabTrigger);
      });
    });
    activate(tabs[0].dataset.tabTrigger);
  });

  document.querySelectorAll('.product-full-description iframe[src*="vimeo.com"]').forEach((iframe) => {
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.classList.add('product-description-video__iframe');
    const wrapper = iframe.parentElement;
    if (wrapper && wrapper.closest('.product-full-description')) {
      wrapper.classList.add('product-description-video');
      wrapper.style.removeProperty('height');
      wrapper.style.removeProperty('padding');
      wrapper.style.removeProperty('padding-top');
      wrapper.style.removeProperty('padding-bottom');
    }
  });

  const CartDrawer = (() => {
    const rootSelector = '[data-cart-drawer-root]';
    const getRoot = () => document.querySelector(rootSelector);
    const getDrawer = () => document.querySelector('[data-cart-drawer]');
    const getBackdrop = () => document.querySelector('.cart-drawer-backdrop');

    let scrollIndicatorCleanup = null;

    const setupMobileScrollIndicator = () => {
      if (scrollIndicatorCleanup) {
        scrollIndicatorCleanup();
        scrollIndicatorCleanup = null;
      }

      const scroll = document.querySelector('[data-cart-items-scroll]');
      const rail = document.querySelector('[data-cart-scrollbar]');
      const thumb = document.querySelector('[data-cart-scrollbar-thumb]');
      if (!scroll || !rail || !thumb) return;

      const update = () => {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const maxScroll = Math.max(0, scroll.scrollHeight - scroll.clientHeight);
        const overflow = maxScroll > 8;

        rail.hidden = !(isMobile && overflow);
        if (!isMobile || !overflow) return;

        const railHeight = rail.clientHeight;
        const ratio = scroll.clientHeight / Math.max(scroll.scrollHeight, 1);
        const thumbHeight = Math.max(34, Math.min(railHeight, railHeight * ratio));
        const travel = Math.max(0, railHeight - thumbHeight);
        const progress = maxScroll > 0 ? scroll.scrollTop / maxScroll : 0;

        thumb.style.height = `${thumbHeight}px`;
        thumb.style.transform = `translate3d(0, ${travel * progress}px, 0)`;
      };

      scroll.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });

      requestAnimationFrame(update);
      window.setTimeout(update, 120);

      scrollIndicatorCleanup = () => {
        scroll.removeEventListener('scroll', update);
        window.removeEventListener('resize', update);
      };
    };

    const syncCount = () => {
      const count = Number(getRoot()?.dataset.cartCount || 0);
      document.querySelectorAll('.cart-link').forEach((link) => {
        let badge = link.querySelector('.cart-count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'cart-count';
            link.appendChild(badge);
          }
          badge.textContent = String(count);
        } else if (badge) badge.remove();
      });
    };

    const open = () => {
      const drawer = getDrawer();
      const backdrop = getBackdrop();
      if (!drawer || !backdrop) return;
      drawer.hidden = false;
      backdrop.hidden = false;
      requestAnimationFrame(() => {
        document.body.classList.add('cart-drawer-open');
        drawer.setAttribute('aria-hidden', 'false');
        setupMobileScrollIndicator();
      });
    };

    const close = () => {
      const drawer = getDrawer();
      const backdrop = getBackdrop();
      if (!drawer || !backdrop) return;
      document.body.classList.remove('cart-drawer-open');
      drawer.setAttribute('aria-hidden', 'true');
      window.setTimeout(() => {
        if (!document.body.classList.contains('cart-drawer-open')) {
          drawer.hidden = true;
          backdrop.hidden = true;
        }
      }, 280);
    };

    const refresh = async (shouldOpen = true) => {
      const response = await fetch(window.location.href, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        cache: 'no-store'
      });
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const incoming = doc.querySelector(rootSelector);
      const current = getRoot();
      if (incoming && current) current.replaceWith(incoming);
      syncCount();
      if (shouldOpen) open();
    };

    const changeLine = async (line, quantity) => {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity: Math.max(0, Number(quantity) || 0) })
      });
      await refresh(true);
    };

    const saveNote = async () => {
      const note = document.querySelector('[data-cart-drawer-note]')?.value || '';
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note })
      });
    };

    document.addEventListener('click', async (event) => {
      const openTrigger = event.target.closest('[data-cart-drawer-open]');
      if (openTrigger) {
        event.preventDefault();
        open();
        return;
      }
      if (event.target.closest('[data-cart-drawer-close]')) {
        event.preventDefault();
        close();
        return;
      }
      const remove = event.target.closest('[data-cart-line-remove]');
      if (remove) {
        event.preventDefault();
        await changeLine(remove.dataset.cartLineRemove, 0);
        return;
      }
      const change = event.target.closest('[data-cart-line-change]');
      if (change) {
        event.preventDefault();
        change.disabled = true;
        try { await changeLine(change.dataset.cartLineChange, change.dataset.cartQuantity); }
        finally { change.disabled = false; }
        return;
      }
      const continueShopping = event.target.closest('[data-cart-drawer-continue]');
      if (continueShopping) {
        event.preventDefault();
        const previous = continueShopping.textContent;
        continueShopping.disabled = true;
        continueShopping.textContent = 'Salvando...';
        try {
          await saveNote();
          close();
        } finally {
          continueShopping.disabled = false;
          continueShopping.textContent = previous;
        }
        return;
      }
      const checkout = event.target.closest('[data-cart-drawer-checkout]');
      if (checkout) {
        event.preventDefault();
        checkout.disabled = true;
        try { await saveNote(); } catch {}
        window.location.href = '/checkout';
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && document.body.classList.contains('cart-drawer-open')) close();
    });

    syncCount();
    setupMobileScrollIndicator();
    return { open, close, refresh };
  })();
  window.StorkidsCartDrawer = CartDrawer;

});

// ===== v63: carrossel dos benefícios no mobile =====
(() => {
  const initBenefitsCarousels = () => {
    document.querySelectorAll('[data-benefits-carousel]').forEach((section) => {
      const track = section.querySelector('[data-benefits-track]');
      const slides = [...section.querySelectorAll('[data-benefit-slide]')];
      const dots = [...section.querySelectorAll('[data-benefit-dot]')];
      if (!track || slides.length < 2 || dots.length !== slides.length) return;
      if (section.dataset.carouselReady === 'true') return;
      section.dataset.carouselReady = 'true';

      let raf = null;
      const updateDots = () => {
        raf = null;
        if (!window.matchMedia('(max-width: 749px)').matches) {
          dots.forEach((dot, i) => dot.classList.toggle('is-active', i === 0));
          return;
        }

        const trackRect = track.getBoundingClientRect();
        const targetX = trackRect.left + Math.min(42, trackRect.width * 0.12);

        let bestIndex = 0;
        let bestDistance = Infinity;
        slides.forEach((slide, i) => {
          const rect = slide.getBoundingClientRect();
          const distance = Math.abs(rect.left - targetX);
          if (distance < bestDistance) {
            bestDistance = distance;
            bestIndex = i;
          }
        });

        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === bestIndex));
      };

      const requestUpdate = () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(updateDots);
      };

      track.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      requestAnimationFrame(updateDots);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBenefitsCarousels, { once: true });
  } else {
    initBenefitsCarousels();
  }

  document.addEventListener('shopify:section:load', initBenefitsCarousels);
})();


// ===== v72: modal de rastreamento =====
(() => {
  const modal = document.querySelector('[data-tracking-modal]');
  const backdrop = document.querySelector('[data-tracking-backdrop]');
  const openers = document.querySelectorAll('[data-tracking-open]');
  const closeButton = document.querySelector('[data-tracking-close]');
  const form = document.querySelector('[data-tracking-form]');
  const input = document.querySelector('[data-tracking-code]');

  if (!modal || !backdrop || !openers.length) return;

  const openTracking = (event) => {
    if (event) event.preventDefault();

    // Se o menu mobile estiver aberto, fecha antes de mostrar o rastreio.
    const mobileMenu = document.querySelector('#MobileMenu');
    const menuBackdrop = document.querySelector('[data-menu-backdrop]');
    if (mobileMenu && !mobileMenu.hidden) mobileMenu.hidden = true;
    if (menuBackdrop && !menuBackdrop.hidden) menuBackdrop.hidden = true;
    document.body.classList.remove('menu-open');

    modal.hidden = false;
    backdrop.hidden = false;
    document.body.classList.add('tracking-modal-open');

    window.setTimeout(() => input?.focus(), 60);
  };

  const closeTracking = () => {
    modal.hidden = true;
    backdrop.hidden = true;
    document.body.classList.remove('tracking-modal-open');
  };

  openers.forEach((opener) => opener.addEventListener('click', openTracking));
  closeButton?.addEventListener('click', closeTracking);
  backdrop.addEventListener('click', closeTracking);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeTracking();
  });

  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    const code = (input?.value || '').trim();
    if (!code) {
      input?.focus();
      return;
    }

    const trackingUrl = `https://t.17track.net/pt#nums=${encodeURIComponent(code)}`;
    window.open(trackingUrl, '_blank', 'noopener,noreferrer');
  });
})();


// ===== v74: desenha o rabisco quando ele entra na tela =====
(() => {
  const initChildScribbles = () => {
    document.querySelectorAll('[data-child-scribble]').forEach((scribble) => {
      if (scribble.dataset.scribbleReady === 'true') return;
      scribble.dataset.scribbleReady = 'true';

      const show = () => scribble.classList.add('is-drawn');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        show();
        return;
      }

      if (!('IntersectionObserver' in window)) {
        show();
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          show();
          observer.unobserve(scribble);
        });
      }, {
        threshold: 0.35,
        rootMargin: '0px 0px -8% 0px'
      });

      observer.observe(scribble);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChildScribbles, { once:true });
  } else {
    initChildScribbles();
  }

  document.addEventListener('shopify:section:load', initChildScribbles);
})();
